import { LastRoundPanel } from 'components/issuers/LastRoundDetails'
import { useIssuerLastRoundQuery } from 'graphql/bindings/AdminBindings'
import { useRouter } from '@forgeglobal/design-framework'
import React from 'react'

const IssuerLastRound: React.FC = () => {
  const { match } = useRouter<{ id: string }>()
  const { data } = useIssuerLastRoundQuery({ variables: { issuerId: match.params.id } })
  const lastRound = data?.account?.issuer_account?.company?.last_round

  return <LastRoundPanel lastRound={lastRound} />
}

export { IssuerLastRound }
